import Route from '@ember/routing/route';

export default class AuthenticatedProjectsShowProjectVersionsShowSettingsRoute extends Route {}
